// TMC系统相关api
/* eslint-disable */
export default {
    basePath: process.env.VUE_APP_H5_INQUIRY,
    apiList: {
        // 获取签名
        INITIAL_GET_USER_SIG: "api/rp/initial/getUserSig",
    }
};
